module.exports = __webpack_public_path__ + "img/netease-cloud-music.b0424958.webp";